import styled from "styled-components"
import { media } from "../../../../styles"

export const PostHeader = styled.header`
  margin: 10rem 0 15rem;
  position: relative;

  ${media.phonesmall`
  margin: 7.5rem 0 15rem;
  `}
`
export const PostImage = styled.div`
  width: 100%;
  height: 95vh;
  max-height: 100rem;

  ${media.tabland`
  width: 100%;
  height: 100%;
  `}
`
export const PostHeaderText = styled.div`
  position: absolute;
  z-index: 2;

  bottom: -7.5rem;
  left: 10%;

  display: flex;
  flex-direction: column;
  background-color: var(--color-white);

  border: solid 1px #adadad;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);

  /* transform: translateY(-80%);
  margin-left: 10%; */

  max-width: 80rem;

  padding: 5rem;

  ${media.tabland`
position: relative;
  max-width: 90%;
  left: 5%;

  margin-top: -15rem;
  `}

  ${media.phone`
  margin-top: -10rem;

  `}

  ${media.phonesmall`

  padding: 2rem;

  `}
`

export const PostHeaderCategory = styled.p`
  font-family: var(--font-body);

  font-size: var(--font-size-bodyM);
  margin-bottom: 1rem;

  color: var(--color-grey);
`
export const PostHeaderHeading = styled.h1`
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--font-size-headingS);

  margin: 0;
  margin-bottom: 2rem;
`
export const PostHeaderMeta = styled.p`
  font-family: var(--font-body);
  font-size: var(--font-size-bodyM);
  line-height: var(--line-height-body);

  margin-bottom: 5rem;
  color: var(--color-grey);

  ${media.phonesmall`
  margin-bottom: 2.5rem;

  `}
`
export const PostHeaderExcerpt = styled.p`
  font-family: var(--font-body);
  font-size: var(--font-size-bodyM);

  line-height: var(--line-height-body);
`

export const PostMain = styled.div`
  max-width: 104rem;
  margin: 0 auto 10rem;

  ${media.tabland`
  width: 90%;
  margin: 0 5% 10rem;
  `}

  & p {
    font-family: var(--font-body);
    font-size: var(--font-size-bodyM);
    line-height: var(--line-height-bodyS);

    margin: 2rem 0;
  }

  & li {
    margin-left: 4rem;
    font-family: var(--font-body);
    font-size: var(--font-size-bodyM);
    line-height: var(--line-height-bodyS);
  }

  & h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-family: var(--font-heading);
  }

  & h2 {
    font-size: var(--font-size-headingS);
  }

  & h3 {
    font-size: var(--font-size-subheadingL);
  }

  & h4 {
    font-size: var(--font-size-subheading);
  }

  & h5 {
    font-size: var(--font-size-subheading);
  }

  & h6 {
    font-size: var(--font-size-subheadingS);
  }

  & hr {
    margin: 5rem 0;
  }

  a {
    color: var(--color-blue);

    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  & div {
  }

  & img {
    margin: 2.5rem 0;
    width: 100%;
    height: auto;
  }
`
